export * from './blob.service';
import { BlobService } from './blob.service';
export * from './blog.service';
import { BlogService } from './blog.service';
export * from './blogCategory.service';
import { BlogCategoryService } from './blogCategory.service';
export * from './contactPage.service';
import { ContactPageService } from './contactPage.service';
export * from './deliveryPage.service';
import { DeliveryPageService } from './deliveryPage.service';
export * from './event.service';
import { EventService } from './event.service';
export * from './eventsPage.service';
import { EventsPageService } from './eventsPage.service';
export * from './fAQ.service';
import { FAQService } from './fAQ.service';
export * from './field.service';
import { FieldService } from './field.service';
export * from './flatPage.service';
import { FlatPageService } from './flatPage.service';
export * from './historyCategory.service';
import { HistoryCategoryService } from './historyCategory.service';
export * from './historyInfo.service';
import { HistoryInfoService } from './historyInfo.service';
export * from './homepage.service';
import { HomepageService } from './homepage.service';
export * from './hotelsAndAttractions.service';
import { HotelsAndAttractionsService } from './hotelsAndAttractions.service';
export * from './importExport.service';
import { ImportExportService } from './importExport.service';
export * from './lAXPage.service';
import { LAXPageService } from './lAXPage.service';
export * from './merchant.service';
import { MerchantService } from './merchant.service';
export * from './merchantCategory.service';
import { MerchantCategoryService } from './merchantCategory.service';
export * from './merchantSubCategory.service';
import { MerchantSubCategoryService } from './merchantSubCategory.service';
export * from './order.service';
import { OrderService } from './order.service';
export * from './privacyPolicySections.service';
import { PrivacyPolicySectionsService } from './privacyPolicySections.service';
export * from './product.service';
import { ProductService } from './product.service';
export * from './productCategory.service';
import { ProductCategoryService } from './productCategory.service';
export * from './sKU.service';
import { SKUService } from './sKU.service';
export * from './upload.service';
import { UploadService } from './upload.service';
export * from './visitorCategorySection.service';
import { VisitorCategorySectionService } from './visitorCategorySection.service';
export * from './visitorMapAndHours.service';
import { VisitorMapAndHoursService } from './visitorMapAndHours.service';
export * from './visitorPage.service';
import { VisitorPageService } from './visitorPage.service';
export const APIS = [BlobService, BlogService, BlogCategoryService, ContactPageService, DeliveryPageService, EventService, EventsPageService, FAQService, FieldService, FlatPageService, HistoryCategoryService, HistoryInfoService, HomepageService, HotelsAndAttractionsService, ImportExportService, LAXPageService, MerchantService, MerchantCategoryService, MerchantSubCategoryService, OrderService, PrivacyPolicySectionsService, ProductService, ProductCategoryService, SKUService, UploadService, VisitorCategorySectionService, VisitorMapAndHoursService, VisitorPageService];
